import * as z from 'zod';

export const ContactEmailSchema = z.object({
  name: z.string().min(1).max(200),
  email: z.string().email(),
  message: z.string().min(1).max(5000),
  // Shared client/server Meta event id so the browser pixel Lead and the
  // server CAPI Lead deduplicate into one conversion.
  eventId: z.string().uuid().optional(),
});
